// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const trubbish: PokeData = {
  "id": 568,
  "name": "trubbish",
  "height": 6,
  "weight": 310,
  "base_experience": 66,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "take-down",
    "toxic",
    "sludge",
    "amnesia",
    "poison-gas",
    "explosion",
    "sludge-bomb",
    "pain-split",
    "stockpile",
    "swallow",
    "recycle",
    "toxic-spikes",
    "gunk-shot",
    "acid-spray",
    "clear-smog",
    "belch"
  ],
  "moves": [
    "poison-gas",
    "sludge-bomb",
    "toxic-spikes",
    "acid",
    "stun-spore",
    "poison-powder",
    "poison-jab",
    "venom-drench",
    "toxic-overload",
    "mortal-gas",
    "purify",
    "acid-rain",
    "poison-fang"
  ],
  "evolution_chain": {
    "id": 290,
    "item": null,
    "species": [
      {
        "name": "trubbish",
        "order": 569,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "garbodor",
        "order": 570,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 568,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56,
    "speed": 65,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
